<div class="hero-container darkbg">
  <div class="container-fluid">
    <div class="container pt-3">
      <div class="row">
        <div class="col-12 col-lg-6 hero-container-left-side">
          <h3 class="yellow text-uppercase">
            The future of pharmaceutical sourcing
          </h3>
          <h1 class="white">
            welcome to<br />
            our one-stop<br />
            marketplace.
          </h1>
        </div>
        <div class="col-12 col-lg-6 hero-container-right-side">
          <app-laptop-video></app-laptop-video>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid second-container">
    <div class="container justify-content-center align-items-center">
      <div class="row">
        <div class="col-12 col-xl-12">
          <h2
            class="text-center white"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="0"
            data-aos-once="true"
          >
            ready to experience the medigi difference?
          </h2>
        </div>
      </div>
    </div>

    <div class="container justify-content-center align-items-center">
      <div class="row mt-5">
        <div class="col-6 col-lg-3 mb-5 mb-0-lg">
          <div
            class="value-prop"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="250"
            data-aos-once="true"
            data-aos-offset="0"
          >
            <img
              class="value-prop-image"
              src="/assets/img/static-pages/medigi/v2-images/standalone-icons/plus-circle.svg"
              alt="Plus"
            />
            <p class="value-prop-text">Free to join</p>
            <span class="value-prop-line"></span>
          </div>
        </div>
        <div class="col-6 col-lg-3 mb-5 mb-0-lg">
          <div
            class="value-prop"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="500"
            data-aos-once="true"
            data-aos-offset="0"
          >
            <img
              class="value-prop-image"
              src="/assets/img/static-pages/medigi/v2-images/standalone-icons/graph.svg"
              alt="Graph"
            />
            <p class="value-prop-text">
              Easy-to-use portal &<br />
              custom analytics
            </p>
            <span class="value-prop-line"></span>
          </div>
        </div>
        <div class="col-6 col-lg-3 mb-5 mb-0-lg">
          <div
            class="value-prop"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="750"
            data-aos-once="true"
            data-aos-offset="0"
          >
            <img
              class="value-prop-image"
              src="/assets/img/static-pages/medigi/v2-images/standalone-icons/speech-icon.svg"
              alt="Negotiate"
            />
            <p class="value-prop-text">
              Direct negotiation between<br />
              pharmacies & manufacturers
            </p>
            <span class="value-prop-line"></span>
          </div>
        </div>
        <div class="col-6 col-lg-3 mb-5 mb-0-lg">
          <div
            class="value-prop"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="1000"
            data-aos-once="true"
            data-aos-offset="0"
          >
            <img
              class="value-prop-image"
              src="/assets/img/static-pages/medigi/v2-images/standalone-icons/invoice-icon.svg"
              alt="Invoice"
            />
            <p class="value-prop-text">Consolidated invoices</p>
            <span class="value-prop-line"></span>
          </div>
        </div>
      </div>
    </div>

    <div
      class="container-fluid pb-5 d-flex justify-content-center align-items-center hero-bottom-bg"
    >
      <div class="container">
        <div class="row mt-5">
          <div
            class="col-12 col-lg-6 d-flex justify-content-center align-items-center mb-5"
          >
            <div class="button-container">
              <app-button
                style="width: 100%"
                [buttonColor]="'yellow'"
                [buttonText]="'I\u0027m a pharmacy'"
                [buttonIcon]="'chevronright'"
                [buttonLink]="'/pharmacy-info'"
                [buttonType]="'button'"
                (click)="sendToGa('Went To Pharmacy Info', 'HomePage')"
              ></app-button>
              <p class="white text-center">
                access inventory from more than<br />
                80 manufacturers
              </p>
            </div>
          </div>
          <div
            class="col-12 col-lg-6 d-flex justify-content-center align-items-center mb-5"
          >
            <div class="button-container">
              <app-button
                style="width: 100%"
                [buttonColor]="'yellow'"
                [buttonText]="'I\u0027m a manufacturer'"
                [buttonIcon]="'chevronright'"
                [buttonLink]="'/manufacturer-info'"
                [buttonType]="'button'"
                (click)="sendToGa('Went To Manufacturer Info', 'HomePage')"
              ></app-button>
              <p class="white text-center">
                boost portfolio exposure<br />
                to thousands of pharmacies
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="container-fluid third-container d-flex justify-content-center align-items-center"
>
  <div class="container">
    <div class="row align-items-center justify-content-around">
      <div class="col-12 col-xl-5 third-container-left-side">
        <h2 class="green mb-3">what we do</h2>
        <p class="blue">
          We simplify pharmacy drug purchasing by providing a platform for
          manufacturers to service direct orders online. With a single sign-on,
          hospital systems, community oncology practices, and various types of
          pharmacies can access our three channels to view a robust inventory
          list from pharmaceutical manufacturers.
        </p>
      </div>
      <div class="col-12 col-xl-5 third-container-right-side">
        <app-carousel-static [location]="'websites'"></app-carousel-static>
      </div>
    </div>
  </div>
</div>

<div
  class="container-fluid fourth-container d-flex justify-content-center align-items-center"
>
  <div class="container">
    <div class="row py-3">
      <div class="col-12 col-md-6">
        <h2 class="white mb-4">who we are</h2>
        <p class="white mb-5">
          We are entrepreneurs, engineers, and healthcare industry leaders with
          experience in pharmaceutical, eCommerce, and technology development.
          Our dedicated team is driven to simplify pharmaceutical sourcing
          through innovation.
        </p>
        <app-button
          class="d-flex"
          [buttonColor]="'yellow'"
          [buttonText]="'get to know our team'"
          [buttonIcon]="'chevronright'"
          [buttonLink]="'/about'"
          [buttonType]="'button'"
          (click)="sendToGa('Went To About Us', 'HomePage')"
        ></app-button>
      </div>
    </div>
  </div>
</div>

<div
  class="container-fluid fifth-container d-flex justify-content-center align-items-center whitebg"
>
  <div class="container">
    <div class="row align-items-center justify-content-between">
      <div class="col-12 col-xl-5 pr-0 pr-md-5 py-6">
        <h2 class="green mb-3">how it works</h2>
        <p class="blue">
          We work at the intersection of technology and transparency, saving you
          valuable time while improving procurement costs.
        </p>
      </div>

      <div class="col-12 col-xl-6 scrollsection">
        <div class="scrollcards">
          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/factory-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 1</h6>
                <p class="step-card-copy text-wrap text-left">
                  Drug manufacturers list their chosen inventory on the medigi
                  platform
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/desktop-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 2</h6>
                <p class="step-card-copy text-wrap text-left">
                  Hospital systems, medical centers, and pharmacies shop,
                  negotiate, and order product(s) through medigi
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/shipping-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 3</h6>
                <p class="step-card-copy text-wrap text-left">
                  Manufacturers ship products directly to the purchaser
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/phone-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 4</h6>
                <p class="step-card-copy text-wrap text-left">
                  Shipments are tracked in real time
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/envelope-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 5</h6>
                <p class="step-card-copy text-wrap text-left">
                  Consolidated invoices are sent to the purchaser after the
                  products are received
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/check-ribbon-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 6</h6>
                <p class="step-card-copy text-wrap text-left">
                  Payments are collected and disbursed to the respective
                  manufacturers
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- <app-carousel-static class="stepcards" [type]="'stepcards'" [location]="'home'"></app-carousel-static> -->
      </div>
    </div>
  </div>
</div>

<div
  class="container-fluid sixth-container d-flex justify-content-center align-items-center"
>
  <div class="container">
    <div class="row">
      <div class="col-12 col-xl-12">
        <app-large-card
          style="width: 61%; z-index: 2"
          [cardType]="'carousel'"
          [cardInfo]="cardInfo"
        ></app-large-card>
      </div>
    </div>
  </div>
</div>

<div
  class="container-fluid seventh-container d-flex justify-content-center align-items-center"
>
  <div class="container">
    <div class="row">
      <div class="col-12 col-xl-6 seventh-container-left-side">
        <h4 class="yellow mb-1">MEDIGI SWAG SHOP</h4>
        <h3 class="white fs-2 pb-3">brag-worthy merch is a click away</h3>
        <app-button
          class="mt-3 d-flex"
          style="width: 250px"
          [buttonColor]="'lime'"
          [buttonText]="'snag our swag'"
          [buttonIcon]="'chevronright'"
          [buttonLink]="'outbound'"
          [buttonType]="'button'"
          (click)="sendToGa('Went to Medigi Swag', 'HomePage')"
        ></app-button>
      </div>
      <div class="col-12 col-xl-4 seventh-container-right-side">
        <h2 class="white mb-1">questions?</h2>
        <p class="white mb-2">
          We’re here to help. Get started with a representative by phone, email,
          or live chat.
        </p>

        <a
          class="yellow d-flex align-items-center fw-bold mb-4"
          href="#"
          style="font-size: 18px; margin-top: 1rem"
          data-toggle="modal"
          data-target="#modal"
        >
          connect with us <i class="dx-icon-chevronright"></i>
        </a>
      </div>
    </div>
  </div>
</div>
